import { parse as parseDateFns, isValid } from "date-fns";
import { isComplianceDeadlineReminder } from "./complianceDeadlineReminder";

/** Parse slash-separated reminder date (MM/DD/YYYY or DD/MM/YYYY). */
export function parseReminderDateString(dateStr) {
  const s = String(dateStr ?? "").trim();
  if (!s) return new Date(NaN);

  const parts = s.split("/");
  if (parts.length === 3) {
    const a = parseInt(parts[0], 10);
    const b = parseInt(parts[1], 10);
    const y = parseInt(parts[2], 10);
    if (!Number.isNaN(a) && !Number.isNaN(b) && !Number.isNaN(y)) {
      if (a > 12 && b <= 12) {
        return new Date(y, b - 1, a);
      }
      if (b > 12 && a <= 12) {
        return new Date(y, a - 1, b);
      }
    }
  }

  const mmdd = parseDateFns(s, "MM/dd/yyyy", new Date());
  if (isValid(mmdd)) return mmdd;

  const ddmm = parseDateFns(s, "dd/MM/yyyy", new Date());
  if (isValid(ddmm)) return ddmm;

  return new Date(NaN);
}

export function formatMMDDYYYY(dateObj) {
  if (!dateObj || Number.isNaN(dateObj.getTime())) return "";
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${month}/${day}/${year}`;
}

export function formatDDMMYYYY(dateObj) {
  if (!dateObj || Number.isNaN(dateObj.getTime())) return "";
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${day}/${month}/${year}`;
}

/** Compare reminder date string to a calendar-selected day. */
export function reminderMatchesCalendarDay(reminderDateStr, selectedDateObj) {
  const reminderDay = parseReminderDateString(reminderDateStr);
  const selected = new Date(selectedDateObj);
  if (Number.isNaN(reminderDay.getTime()) || Number.isNaN(selected.getTime())) {
    return false;
  }
  reminderDay.setHours(0, 0, 0, 0);
  selected.setHours(0, 0, 0, 0);
  return reminderDay.getTime() === selected.getTime();
}

/** Display compliance reminder dates as MM/DD/YYYY in the UI. */
export function formatReminderDateForDisplay(dateStr, reminderText) {
  const parsed = parseReminderDateString(dateStr);
  if (Number.isNaN(parsed.getTime())) return dateStr;
  if (isComplianceDeadlineReminder(reminderText)) {
    return formatMMDDYYYY(parsed);
  }
  return dateStr;
}
